export const CANCEL_FOR_ANY_REASON_TITLE = "Cancel for Any Reason (Flights)";
export const CANCEL_FOR_ANY_REASON_SUBTITLE = "Terms and Conditions";

export const HOTEL_CANCEL_FOR_ANY_REASON_TITLE =
  "Cancel for Any Reason (Hotels)";
export const HOTEL_CANCEL_FOR_ANY_REASON_SUBTITLE = "Terms and Conditions";
